import { render, staticRenderFns } from "./InputStatusLabel.vue?vue&type=template&id=856b183e"
import script from "./InputStatusLabel.vue?vue&type=script&lang=js"
export * from "./InputStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports